	// document.addEventListener("DOMContentLoaded", function() {
	// 	var header = document.querySelector('.lower-header');
	// 	var lastScroll = window.pageYOffset || document.documentElement.scrollTop;
	// 	var stickyThreshold = 500; // Adjust this value as needed
	
	// 	window.addEventListener("scroll", function() {
	// 		var currentScroll = window.pageYOffset || document.documentElement.scrollTop;
	
	// 		if (currentScroll > stickyThreshold) {
	// 			header.classList.add("sticky");
	// 		} else {
	// 			header.classList.remove("sticky");
	// 		}
	
	// 		// Only remove the sticky class if scrolling up and we're below the threshold
	// 		if (currentScroll <= stickyThreshold && currentScroll < lastScroll) {
	// 			header.classList.remove("sticky");
	// 		}
	
	// 		lastScroll = currentScroll;
	// 	});
	// });



// dropdown

// Select all search forms
const searchForms = document.querySelectorAll(".inner-search");

// Add click event listeners to all search forms
searchForms.forEach((searchForm) => {
  const searchButton = searchForm.querySelector(".s-btn");
  const fieldInner = searchForm.querySelector(".field-inner");

  // Show search input on button click
  searchButton.addEventListener("click", (e) => {
    e.stopPropagation(); // Prevent click from propagating to the document
    fieldInner.classList.toggle("active");
  });

  // Hide search input if clicked outside
  document.addEventListener("click", (e) => {
    if (!searchForm.contains(e.target)) {
      fieldInner.classList.remove("active");
    }
  });
});

$(document).ready(function () {
  var sync1 = $("#sync1");
  var sync2 = $("#sync2");
  var slidesPerPage = 3; //globaly define number of elements per page
  var syncedSecondary = true;

  sync1
    .owlCarousel({
      items: 1,
      slideSpeed: 2000,
      nav: false,
      autoplay: true,
      dots: false,
      loop: true,
      responsiveRefreshRate: 200,
     
    })
    .on("changed.owl.carousel", syncPosition);

  sync2
    .on("initialized.owl.carousel", function () {
      sync2.find(".owl-item").eq(0).addClass("current");
    })
    .owlCarousel({
      items: slidesPerPage,
      dots: true,
      nav: true,
      smartSpeed: 200,
      slideSpeed: 500,
      slideBy: 1, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
      responsiveRefreshRate: 100,
    })
    .on("changed.owl.carousel", syncPosition2);

  function syncPosition(el) {
    //if you set loop to false, you have to restore this next line
    //var current = el.item.index;

    //if you disable loop you have to comment this block
    var count = el.item.count - 1;
    var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

    if (current < 0) {
      current = count;
    }
    if (current > count) {
      current = 0;
    }

    //end block

    sync2.find(".owl-item").removeClass("current").eq(current).addClass("current");
    var onscreen = sync2.find(".owl-item.active").length - 1;
    var start = sync2.find(".owl-item.active").first().index();
    var end = sync2.find(".owl-item.active").last().index();

    if (current > end) {
      sync2.data("owl.carousel").to(current, 100, true);
    }
    if (current < start) {
      sync2.data("owl.carousel").to(current - onscreen, 100, true);
    }
  }

  function syncPosition2(el) {
    if (syncedSecondary) {
      var number = el.item.index;
      sync1.data("owl.carousel").to(number, 100, true);
    }
  }

  sync2.on("click", ".owl-item", function (e) {
    e.preventDefault();
    var number = $(this).index();
    sync1.data("owl.carousel").to(number, 300, true);
  });
});

// FVRT-BTN

const favoriteButtons = document.querySelectorAll(".favorite-button");

favoriteButtons.forEach((button) => {
  button.addEventListener("click", (event) => {
    event.currentTarget.classList.toggle("is-favorite");
  });
});

// product-carousale
$(".custom-home-collection-slider").owlCarousel({
  loop: true,
  margin: 10,
  dots: false,
  responsive: {
    0: {
      items: 1.2,
      nav: false,
    },
    700: {
      items: 2.1,
      nav: false,
    },
    992: {
      items: 2,
      nav: false,
    },
    1000: {
      items: 3,
      nav: true,
    },
  },
});


$(".may-like-carousal").owlCarousel({
  loop: true,
  margin: 10,
  dots: false,
  responsive: {
    0: {
      items: 1.5,
      nav: false,
    },
    600: {
      items: 2.1,
      nav: false,
    },
    1000: {
      items: 4,
      nav: true,
    },
  },
});


$(".may-like-carousal-prod").owlCarousel({
  loop: true,
  margin: 10,
  dots: false,
  responsive: {
    0: {
      items: 1.5,
      nav: false,
    },
    600: {
      items: 2.1,
      nav: false,
    },
    1000: {
      items: 4,
      nav: true,
    },
  },
});

$(".reviews-carousal").owlCarousel({
  loop: true,
  margin: 10,
  dots: false,
  nav:false,
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 1,
    },
    1500: {
      items: 1,
    },
  },
});

function showMenu() {
  var menu = document.querySelector(".menu-offcanva-cs");
  var overlay = document.querySelector(".overlay");

  menu.classList.add("smenu-1");
  overlay.classList.add("active"); // Show overlay when menu is opened
}

function closeMenu() {
  var menu = document.querySelector(".menu-offcanva-cs");
  var overlay = document.querySelector(".overlay");

  menu.classList.remove("smenu-1");
  overlay.classList.remove("active"); // Hide overlay when menu is closed
}

document.addEventListener("click", function(event) {
  const searchIcon = document.getElementById("search-icon");
  const searchInputBar = document.querySelector(".search-input-bar");
  
  // When search icon is clicked, show the input bar
  if (searchIcon && searchIcon.contains(event.target)) {
    searchInputBar.classList.add("active");
  } 
  // Hide the search bar if clicked outside
  else if (searchInputBar && !searchInputBar.contains(event.target)) {
    searchInputBar.classList.remove("active");
  }
});
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
acc[i].addEventListener("click", function() {
  // Close all other accordions
  for (var j = 0; j < acc.length; j++) {
    if (acc[j] !== this) {
      acc[j].classList.remove("active");
      var otherPanel = acc[j].nextElementSibling;
      otherPanel.style.maxHeight = null;
    }
  }

  // Toggle the clicked accordion
  this.classList.toggle("active");
  var panel = this.nextElementSibling;
  if (panel.style.maxHeight) {
    panel.style.maxHeight = null;
  } else {
    panel.style.maxHeight = panel.scrollHeight + "px";
  }
});
}



function playVideo() {
  var overlay = document.getElementById("overlay");
  var video = document.getElementById("myVideo");
  video.src += "&autoplay=1"; // Append autoplay parameter to URL
  overlay.style.display = "none"; // Hide the overlay
  document.getElementById("playButton").style.display = "none"; // Hide the play button
}




 //
 $(document).ready(function () {
  // Set the first image to active by default
  $('.image-here:first-child').addClass('active');

  // Function to handle hover on titles
  $('#switch-images-title li').hover(function () {
      // Get the title of the hovered item
      var title = $(this).data('image');

      // Hide all images
      $('.image-here').removeClass('active');

      // Show the image corresponding to the hovered title
      $('.image-here[data-title="' + title + '"]').addClass('active');
  });
});


$(document).ready(function () {
  $('#switch-images-title li:first-child').addClass('title-active');

  // Function to handle hover on titles
  $('#switch-images-title li').hover(function () {
      // Remove active class from all titles
      $('#switch-images-title li').removeClass('title-active');

      // Add active class to the hovered title
      $(this).addClass('title-active');
  });
});

$(document).ready(function() {
  $('.minus').click(function () {
    var $input = $(this).parent().find('input');
    var count = parseInt($input.val()) - 1;
    count = count < 1 ? 1 : count;
    $input.val(count);
    $input.change();
    return false;
  });
  $('.plus').click(function () {
    var $input = $(this).parent().find('input');
    $input.val(parseInt($input.val()) + 1);
    $input.change();
    return false;
  });
});


$(document).ready(function () {
  $('.dropdown').children('a').append(function () {
    return '<button type="button" class="btn expander"><i class="icon fa fa-angle-down"></i></button>';
  });

  $('.dropdown').children('ul').hide();

  $('.btn.expander').click(function () {
    $(this).parent().parent().children('ul').slideToggle();
    $(this).parent().toggleClass('current');
    $(this).find('i').toggleClass('fa-angle-up fa-angle-down');
    return false;
  });
});